'use client';
import { useMemo } from 'react';
import { useSearchParams } from 'next/navigation';
import { useGetLangPath } from '@/helpers';
import { useUser } from '@/context/providers/UserProvider';
import { SignInTemplate } from '@weareconceptstudio/account';

const SignIn = () => {
	const searchParams = useSearchParams();
	const { prevRoute } = useUser();
	const getLangPath = useGetLangPath();
	const checkoutPath = getLangPath('checkout');

	const redirectParam = useMemo(() => {
		return searchParams.has('r') ? `?r=${searchParams.get('r')}` : prevRoute === checkoutPath ? `?r=${checkoutPath}` : '';
	}, [prevRoute, searchParams]);

	return <SignInTemplate signUpUrl={`/register${redirectParam}`} />;
};

export default SignIn;
